import classNames from 'classnames';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Meter } from '@udemy/react-messaging-components';
import { MediaObject } from '@udemy/react-structure-components';
import { pathBarStyle } from '../../constants/path-config';
import styles from "./compact-program-progress-card.module.css";
export const CompactProgramProgressCard = props => {
  const {
    program,
    ...componentProps
  } = props;
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(MediaObject, componentProps, /*#__PURE__*/React.createElement("div", {
    style: pathBarStyle(program.path)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['program-info']
  }, /*#__PURE__*/React.createElement(MediaObject.Title, {
    className: `ud-heading-sm ${classNames(styles['program-title'], {
      [styles['program-title-condensed']]: program.completionRatio === 0
    })}`,
    "data-purpose": "program-title",
    href: program.url
  }, program.title), program.completionRatio > 0 && /*#__PURE__*/React.createElement(Meter, {
    value: program.completionRatio,
    min: 0,
    max: 100,
    label: gettext('%(percent)s% complete')
  }), program.completionRatio === 0 && /*#__PURE__*/React.createElement("span", {
    className: `ud-heading-sm ${styles['start-learning']}`
  }, gettext('Start learning'))));
};
//# sourceMappingURL=compact-program-progress-card.react-component.js.map